import React from "react";
import ReactModal from "react-modal";

import { Button } from "../../components/ui";
import "./publish-success-modal.scss";

// Confirmation shown after a draft listing is published on /product/:id.
// Replaces the inline success Alert, which on mobile appeared as an unreadable
// banner above the fold instead of confirming the action.
//
// Fontaine M46A: the two hand-painted actions are the one `ui/Button`. Only the
// controls changed — the `ReactModal` props, the centred panel geometry, its
// Escape/overlay dismissal and `autoFocus` on the confirming action are all
// untouched. `rc-publish-modal__btn` survives as a layout hook only.
const PublishSuccessModal = ({ isOpen, onClose, backUrl }) => (
  <ReactModal
    isOpen={isOpen}
    onRequestClose={onClose}
    className="rc-publish-modal"
    overlayClassName="lm-modal-overlay"
    ariaHideApp={false}
  >
    <div className="rc-publish-modal__icon">
      <img src="/assets/icons/check-white.svg" alt="" />
    </div>

    <h2 className="rc-publish-modal__title">Listing published</h2>

    <p className="rc-publish-modal__body">
      Your listing is now live and visible to others.
    </p>

    <div className="rc-publish-modal__actions">
      <Button
        type="button"
        variant="primary"
        size="md"
        fullWidth
        className="rc-publish-modal__btn"
        onClick={onClose}
        autoFocus
      >
        View listing
      </Button>

      <Button
        to={backUrl}
        variant="secondary"
        size="md"
        fullWidth
        className="rc-publish-modal__btn"
      >
        All listings
      </Button>
    </div>
  </ReactModal>
);

export default PublishSuccessModal;
